/* ===== STEIL — exact thema JS ===== */
(function(){
  var geldFormat = function(cents){
    return '\u20ac' + (cents/100).toFixed(2).replace('.', ',');
  };

  /* ---------- Winkelwagen-lade (Shopify AJAX) ---------- */
  var drawer = document.getElementById('SteilDrawer');
  var overlay = document.getElementById('SteilOverlay');
  var kortingsCode = '';
  try { kortingsCode = localStorage.getItem('steil_code') || ''; } catch(e){}

  function openCart(){ if(drawer){ drawer.classList.add('open'); overlay.classList.add('open'); } }
  function closeCart(){ if(drawer){ drawer.classList.remove('open'); overlay.classList.remove('open'); } }
  window.steilOpenCart = openCart;

  function telPop(){
    document.querySelectorAll('.cart-count').forEach(function(el){
      el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
    });
  }

  function renderCart(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    var items = document.getElementById('SteilDrawerItems');
    if(!items) return;
    if(cart.items.length === 0){
      items.innerHTML = '<p class="drawer-leeg">Je winkelwagen is nog leeg.</p>';
    } else {
      items.innerHTML = cart.items.map(function(item){
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2') + '" alt="">' : '';
        return '<div class="ditem">' +
          '<div class="mini">' + img + '</div>' +
          '<div class="info"><strong>' + item.product_title + '</strong>' +
          '<span>' + geldFormat(item.final_price) + ' p/st</span></div>' +
          '<div class="qty">' +
          '<button type="button" data-wijzig data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="E\u00e9n minder">\u2212</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-wijzig data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="E\u00e9n meer">+</button>' +
          '</div></div>';
      }).join('');
    }
    var totaal = document.getElementById('SteilTotaal');
    if(totaal) totaal.textContent = geldFormat(cart.total_price);
  }

  function haalCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart);
  }

  function voegToe(items, knop){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if(!r.ok) throw new Error('add mislukt');
      return haalCart();
    }).then(function(){
      telPop();
      if(knop){
        var oud = knop.textContent;
        knop.classList.add('toegevoegd');
        knop.textContent = '\u2713 Toegevoegd';
        setTimeout(function(){ knop.classList.remove('toegevoegd'); knop.textContent = oud; }, 1200);
      }
      openCart();
    }).catch(function(){
      alert('Toevoegen is niet gelukt. Controleer of het product op voorraad is.');
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if(t.closest('[data-open-cart]')){ e.preventDefault(); openCart(); }
    if(t.closest('[data-close-cart]')){ closeCart(); }
    var addBtn = t.closest('[data-add-variant]');
    if(addBtn){
      e.preventDefault();
      voegToe([{ id: parseInt(addBtn.getAttribute('data-add-variant'), 10), quantity: parseInt(addBtn.getAttribute('data-add-qty') || '1', 10) }], addBtn);
    }
    var wijzig = t.closest('[data-wijzig]');
    if(wijzig){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: wijzig.getAttribute('data-key'), quantity: parseInt(wijzig.getAttribute('data-qty'), 10) })
      }).then(function(r){ return r.json(); }).then(renderCart);
    }
  });
  if(overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeCart(); sluitPopup(); } });

  /* Kortingscode: opslaan en toepassen bij afrekenen */
  var codeInput = document.getElementById('SteilCodeInput');
  var codeMelding = document.getElementById('SteilCodeMelding');
  var checkoutKnop = document.getElementById('SteilCheckout');
  if(codeInput && kortingsCode){ codeInput.value = kortingsCode; if(codeMelding) codeMelding.textContent = '\u2713 Code ' + kortingsCode + ' wordt toegepast bij het afrekenen'; }
  window.steilPasCodeToe = function(){
    if(!codeInput) return;
    kortingsCode = codeInput.value.trim().toUpperCase();
    try { localStorage.setItem('steil_code', kortingsCode); } catch(e){}
    if(codeMelding) codeMelding.textContent = kortingsCode ? '\u2713 Code ' + kortingsCode + ' wordt toegepast bij het afrekenen' : '';
  };
  if(checkoutKnop){
    checkoutKnop.addEventListener('click', function(e){
      e.preventDefault();
      if(kortingsCode){ window.location.href = '/discount/' + encodeURIComponent(kortingsCode) + '?redirect=/checkout'; }
      else { window.location.href = '/checkout'; }
    });
  }

  /* ---------- Productpagina: aanbod-opties ---------- */
  var opties = document.querySelectorAll('.optie');
  var koopKnop = document.getElementById('SteilKoop');
  var skPrijs = document.getElementById('SteilSkPrijs');
  var gekozen = null;
  function kiesOptie(el){
    opties.forEach(function(o){ o.classList.remove('actief'); var i = o.querySelector('input'); if(i) i.checked = false; });
    el.classList.add('actief');
    var input = el.querySelector('input'); if(input) input.checked = true;
    gekozen = el;
    if(koopKnop) koopKnop.textContent = 'In winkelwagen \u2014 ' + el.getAttribute('data-prijs');
    if(skPrijs) skPrijs.textContent = el.getAttribute('data-label') + ' \u2014 ' + el.getAttribute('data-prijs');
  }
  opties.forEach(function(o){
    o.addEventListener('click', function(){ kiesOptie(o); });
  });
  if(opties.length){
    var vraag = new URLSearchParams(location.search).get('optie');
    var start = vraag ? document.querySelector('.optie[data-optie="' + vraag + '"]') : null;
    kiesOptie(start || document.querySelector('.optie.actief') || opties[0]);
  }
  window.steilKoop = function(){
    if(!gekozen) return;
    voegToe([{ id: parseInt(gekozen.getAttribute('data-variant'), 10), quantity: parseInt(gekozen.getAttribute('data-qty') || '1', 10) }], koopKnop);
  };

  /* ---------- Galerij-thumbnails ---------- */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('.thumb[data-groot]');
    if(!thumb) return;
    var hoofd = document.getElementById('SteilHoofdFoto');
    if(hoofd) hoofd.src = thumb.getAttribute('data-groot');
    document.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('actief'); });
    thumb.classList.add('actief');
  });

  /* ---------- E-mail popup ---------- */
  var popup = document.getElementById('SteilPopup');
  var popupOverlay = document.getElementById('SteilPopupOverlay');
  var popupGeweest = false;
  try { popupGeweest = localStorage.getItem('steil_popup') === '1'; } catch(e){}

  function toonPopup(){
    if(popupGeweest || !popup) return;
    popupGeweest = true;
    try { localStorage.setItem('steil_popup', '1'); } catch(e){}
    popup.classList.add('open'); popupOverlay.classList.add('open');
  }
  function sluitPopup(){
    if(popup){ popup.classList.remove('open'); popupOverlay.classList.remove('open'); }
  }
  window.steilSluitPopup = sluitPopup;
  window.steilKortingNaarWagen = function(){
    if(codeInput){ codeInput.value = 'STEIL10'; window.steilPasCodeToe(); }
    sluitPopup();
  };

  if(popup){
    /* Na inschrijving stuurt Shopify terug met ?customer_posted=true */
    if(new URLSearchParams(location.search).get('customer_posted') === 'true'){
      var intro = document.getElementById('SteilPopupIntro');
      var succes = document.getElementById('SteilPopupSucces');
      if(intro) intro.hidden = true;
      if(succes) succes.hidden = false;
      popupGeweest = false;
      toonPopup();
      popupGeweest = true;
    } else {
      setTimeout(toonPopup, 8000);
      window.addEventListener('scroll', function(){
        var diepte = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
        if(diepte > 0.35) toonPopup();
      }, { passive: true });
    }
    if(popupOverlay) popupOverlay.addEventListener('click', sluitPopup);
  }

  /* ---------- Scroll-reveal ---------- */
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var kandidaten = document.querySelectorAll('.js-reveal');
    kandidaten.forEach(function(el){ el.classList.add('reveal'); });
    var groepen = new Map();
    kandidaten.forEach(function(el){
      var g = groepen.get(el.parentElement) || [];
      g.push(el); groepen.set(el.parentElement, g);
    });
    groepen.forEach(function(lijst){
      lijst.forEach(function(el, i){ el.style.transitionDelay = Math.min(i*80, 320) + 'ms'; });
    });
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('zichtbaar'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    kandidaten.forEach(function(el){ obs.observe(el); });
  }

  haalCart();
})();
